import React from 'react'

import { Button } from 'antd'
import { HStack, Text, VStack } from 'govwell-ui'

export type AIChatMessageAction = {
  id: string
  icon: React.ReactNode
  onSelect: () => void
}

export type AIChatMessageProps = {
  id: string
  actions?: AIChatMessageAction[]
  content: React.ReactNode
  isThinking?: boolean
  type: 'Assistant' | 'User'
}

const AIChatMessage = ({ type, content, isThinking, actions }: AIChatMessageProps) => {
  const isUser = type === 'User'

  const messageStyling = [
    'w-full',
    'px-3',
    'py-2',
    'break-words',
    'whitespace-pre-wrap',
    'mt-2',
    ...(isUser ? ['rounded-xl', 'bg-gray-100', 'shadow'] : ['mb-1']), // Add a little extra margin for the assistant message
  ]

  const isStringContent = typeof content === 'string'

  return (
    <VStack
      width="fit-content"
      maxWidth={`${isUser ? '75%' : '100%'}`}
      className={`mr-4 ${isUser ? 'self-end' : 'self-start'}`}
    >
      <VStack gap={4} className={messageStyling.join(' ')}>
        {isStringContent && !content.trim() && (
          <Text.Label className="animate-shimmer" aria-live="polite">
            …
          </Text.Label>
        )}
        {isStringContent ? <Text.Body>{content}</Text.Body> : content}
        {isThinking && (
          <Text.Label className="animate-shimmer" aria-live="polite">
            Thinking…
          </Text.Label>
        )}
      </VStack>
      {actions && actions.length > 0 && (
        <HStack gap={2} className={`${isUser ? 'justify-end' : 'justify-start'}`}>
          {actions.map((action) => (
            <Button
              key={action.id}
              type="text"
              onClick={action.onSelect}
              className="text-neutral-500 hover:text-neutral-700"
            >
              {action.icon}
            </Button>
          ))}
        </HStack>
      )}
    </VStack>
  )
}

export default React.memo(AIChatMessage)
